/**
 * Sous-composants de LandingTemplate, isolés dans un fichier séparé pour éviter
 * que le plugin babel "visual-edits" boucle sur l'analyse des `.map()` imbriqués.
 */

export const PricingHeaderCell = ({ label, isFirst }) => (
  <th scope="col" className={isFirst ? "p-4 font-semibold text-left" : "p-4 font-semibold text-center"}>
    {label}
  </th>
);

export const PricingDataCell = ({ value, columnIndex, textCls }) => {
  if (columnIndex === 0) return <td className="p-4 font-medium text-slate-900">{value}</td>;
  if (columnIndex === 1) return <td className={`p-4 text-center font-semibold ${textCls}`}>{value}</td>;
  return <td className="p-4 text-center text-slate-700">{value}</td>;
};

export const PricingRow = ({ cells, hoverCls, textCls }) => (
  <tr className={`border-t border-slate-100 ${hoverCls} transition-colors`}>
    {cells.map((cell, j) => (
      <PricingDataCell key={j} value={cell} columnIndex={j} textCls={textCls} />
    ))}
  </tr>
);

export const FaqItem = ({ index, q, a, hoverCls, textCls }) => (
  <li className={`bg-slate-50 ${hoverCls} rounded-xl p-6 transition-colors`} data-testid={`faq-${index}`}>
    <h3 className="font-bold text-lg text-slate-900 mb-2 flex gap-3">
      <span className={`${textCls} flex-shrink-0`}>{index + 1}.</span>
      <span>{q}</span>
    </h3>
    <p className="text-slate-700 leading-relaxed pl-7">{a}</p>
  </li>
);

export const FeatureCard = ({ index, Icon, title, description, bgIconCls, textCls }) => (
  <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-slate-100" data-testid={`feature-${index}`}>
    <div className={`w-12 h-12 rounded-xl ${bgIconCls} flex items-center justify-center mb-4`}>
      <Icon className={`h-6 w-6 ${textCls}`} />
    </div>
    <h3 className="text-lg font-bold text-slate-900 mb-2">{title}</h3>
    <p className="text-slate-600 text-sm leading-relaxed">{description}</p>
  </div>
);

export const BrandItem = ({ name, hoverCls }) => (
  <li className={`bg-slate-50 ${hoverCls} px-4 py-3 rounded-lg text-center text-slate-700 font-medium transition-colors`}>
    {name}
  </li>
);
